import { Mapper } from "../../../../base/utils/mapper";
import { UserModel } from "../../../../domain/models/user/user.model";
import { UserEntity } from "../entities/user.entity";


export class UserImplementationRepositoryMapper extends Mapper<UserEntity, UserModel> {
    mapFrom(param: UserEntity): UserModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors,
            showMessage:param.showMessage
        };
    }
    mapTo(param: UserModel): UserEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors,
            showMessage: param.showMessage
        }
    }
}